import { render, staticRenderFns } from "./accountLedger.vue?vue&type=template&id=3038053a&scoped=true"
import script from "./accountLedger.vue?vue&type=script&lang=js"
export * from "./accountLedger.vue?vue&type=script&lang=js"
import style0 from "./accountLedger.vue?vue&type=style&index=0&id=3038053a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3038053a",
  null
  
)

export default component.exports